import axios from "axios"

let API_NAME = process.env.VUE_APP_API_NAME;

export default {
  
  async getUserClients(accessToken) {
	let res = await axios.get(API_NAME + "/user_clients", {
		  headers: {
			Authorization: `Bearer ${accessToken}`
		  }
		});
  return res.data;
},
  
}